import React from "react";
import { VerifyMapContainer } from "../../../containers";
const VerifyMap = (props) => {
  return <VerifyMapContainer />;
};

export default VerifyMap;
